import { trendingSwiper } from './_swiper';
import { categoryAccordion } from '../../../../assets/js/core/_categoryStrip';
import { getQuotes } from './_rateQuotes';

window.addEventListener('DOMContentLoaded', () => {
  trendingSwiper();
  categoryAccordion();
  // load quotes on the homepage
  const snapshotSection = document.querySelector('.snapshot');
  if (snapshotSection) {
    getQuotes().then((data) => {
      const mortgageRate = document.getElementById('mortgage-rate');
      if (mortgageRate && data.mortgageRate) {
        mortgageRate.innerHTML = `${data.mortgageRate.quote}%`;
      }
    });
  }
});
